import columns from "./columns";
import formFields from "./formFields";
import previewFields from "./previewFields";

export default {
    entityName: "contracts",
    pageTitle: "Contracts",
    columns,
    formFields: formFields,
    previewFields: previewFields,
    formOptions: {},
};
